(function() {
  'use strict';

  // ============ COUNTDOWN TIMER ============
  function nextIntakeClose() {
    var now = new Date();
    var target = new Date(now);
    var day = now.getDay();
    var daysToSunday = (7 - day) % 7 || 7;
    target.setDate(now.getDate() + daysToSunday);
    target.setHours(23, 59, 59, 0);
    return target;
  }

  var COUNTDOWN_TARGET = nextIntakeClose();

  function pad(n) { return String(n).padStart(2, '0'); }

  function updateCountdowns() {
    var now = Date.now();
    var diff = Math.max(0, COUNTDOWN_TARGET.getTime() - now);
    var d = Math.floor(diff / 86400000); diff -= d * 86400000;
    var h = Math.floor(diff / 3600000); diff -= h * 3600000;
    var m = Math.floor(diff / 60000); diff -= m * 60000;
    var s = Math.floor(diff / 1000);

    var nums = document.querySelector('.urgency-bar .nums');
    if (nums) {
      nums.textContent = pad(d) + 'd : ' + pad(h) + 'h : ' + pad(m) + 'm : ' + pad(s) + 's';
    }

    var cells = document.querySelectorAll('.countdown-big .cd-cell .n');
    if (cells.length === 4) {
      cells[0].textContent = pad(d);
      cells[1].textContent = pad(h);
      cells[2].textContent = pad(m);
      cells[3].textContent = pad(s);
    }
  }

  updateCountdowns();
  setInterval(updateCountdowns, 1000);

  // ============ FAQ ACCORDION ============
  var faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function(item) {
    var btn = item.querySelector('.faq-q');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var wasOpen = item.classList.contains('open');
      faqItems.forEach(function(other) { other.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
    });
  });

  // ============ LIVE ACTIVITY BAR ============
  var NOTIFS = [
    { name: 'Sara',    city: 'Houston',     t: '2 hours ago' },
    { name: 'Aaminah', city: 'Chicago',     t: '5 hours ago' },
    { name: 'Yusuf',   city: 'New Jersey',  t: 'yesterday' },
    { name: 'Hafsa',   city: 'Toronto',     t: 'yesterday' },
    { name: 'Imran',   city: 'Detroit',     t: '2 days ago' }
  ];

  var notifEl = document.querySelector('.live-bar .notif');
  var liveCountEl = document.querySelector('.live-bar .live b');
  var notifIdx = 0;

  function renderNotif() {
    if (!notifEl) return;
    var n = NOTIFS[notifIdx];
    notifEl.style.opacity = '0';
    setTimeout(function() {
      notifEl.innerHTML = '<span class="check">' + String.fromCharCode(10003) + '</span><span><b style="color:#FAF6EE">' +
        n.name + '</b> from ' + n.city + ' booked a Launch Pad <span style="color:#A8A096">' +
        String.fromCharCode(183) + ' ' + n.t + '</span></span>';
      notifEl.style.opacity = '1';
      notifIdx = (notifIdx + 1) % NOTIFS.length;
    }, 300);
  }

  if (notifEl) {
    setInterval(renderNotif, 4000);
  }

  if (liveCountEl) {
    var viewers = parseInt(liveCountEl.textContent) || 23;
    setInterval(function() {
      var change = Math.random() > 0.5 ? 1 : -1;
      viewers = Math.max(14, Math.min(36, viewers + change));
      liveCountEl.textContent = viewers;
    }, 4500);
  }

  // ============ SMOOTH SCROLL FOR ANCHOR LINKS ============
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var href = link.getAttribute('href');
      if (href === '#' || href.length < 2) return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - 60;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });
})();